import { FormGroup } from '@angular/forms';
import { RfaComponents, RfaFormControl, RfaValidators } from '@innogy/feh/rfa';

import type {
  LeadConsentFormControls,
  LeadConsentFormRendering,
} from './lead-consent-form.interface';
import { fieldToValue } from '../utils/field-to-value';
import { LeadConsentFormDefaults } from './lead-consent-form-defaults';

export function getLeadConsentFormControls(
  rendering: LeadConsentFormRendering,
  analyticsComponentName: string = rendering.componentName
): LeadConsentFormControls {
  return {
    allowDataUsage: new RfaFormControl(
      false,
      {
        label: fieldToValue(
          rendering.fields.AllowDataUsageLabel,
          LeadConsentFormDefaults.fields.AllowDataUsageLabel
        ),
        dataAutomationId: 'lead-consent--allow-data-usage',
        validators: [RfaValidators.requiredTrue],
        helpText: fieldToValue(rendering.fields.AllowDataUsageHintText),
        errorMsgs: {
          required: {
            msg: fieldToValue(
              rendering.fields.AllowDataUsageRequiredError,
              LeadConsentFormDefaults.fields.AllowDataUsageRequiredError
            ),
            analytics: {
              componentName: analyticsComponentName,
            },
          },
        },
        analytics: {
          valueChangeTracker: {
            componentName: analyticsComponentName,
          },
        },
      },
      RfaComponents.Checkbox
    ),
    allowPromotionalUpdates: new RfaFormControl(
      false,
      {
        label: fieldToValue(
          rendering.fields.AllowPromotionalUpdatesLabel,
          LeadConsentFormDefaults.fields.AllowPromotionalUpdatesLabel
        ),
        dataAutomationId: 'lead-consent--allow-promotional-updates',
        helpText: fieldToValue(
          rendering.fields.AllowPromotionalUpdatesHintText
        ),
        analytics: {
          valueChangeTracker: {
            componentName: analyticsComponentName,
          },
        },
      },
      RfaComponents.Checkbox
    ),
  };
}

export function createLeadConsentForm(
  rendering: LeadConsentFormRendering
): FormGroup<LeadConsentFormControls> {
  return new FormGroup(getLeadConsentFormControls(rendering));
}
